<p-toast key="global"></p-toast>
<app-state-wrapper></app-state-wrapper>
<router-outlet></router-outlet>
<app-cgv-modal></app-cgv-modal>